import React, { useState, useEffect } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDataProvider } from 'react-admin'
import BaseOneEntityChart from './components/BaseOneEntityChart'

const useStyles = makeStyles(() => ({
  customCard: {
    marginBottom: '1rem',
  },
  section: {
    marginBottom: '1rem',
  },
}))

export const Dashboard = () => {
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const [PartnersTotal, setPartnersTotal] = useState(0)
  const [PartnersChartData, setPartnersChartData] = useState([])
  const [CampaignsTotal, setCampaignsTotal] = useState(0)
  const [CampaignsChartData, setCampaignsChartData] = useState([])
  const [UserDepositsTotal, setUserDepositsTotal] = useState(0)
  const [UserDepositsChartData, setUserDepositsChartData] = useState([])
  const [UsersTotal, setUsersTotal] = useState(0)
  const [UsersChartData, setUsersChartData] = useState([])

  const fetchTotal = async (resource, setTotal) => {
    try {
      const { total } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'createdAt', order: 'DESC' },
        // UNDEFINED_VARIABLE,
      })
      setTotal(total)
    } catch (error) {
      console.error(`Error fetching total for ${resource}:`, error)
    }
  }

  const fetchChartData = async (resource, setChartData, label) => {
    try {
      const { data } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 0 },
        sort: { field: 'createdAt', order: 'ASC' },
        // UNDEFINED_VARIABLE,
      })

      let cumulativeTotal = 0
      const chartData = []
      const groupedData = {}

      data.forEach((item) => {
        const date = new Date(item.createdAt).toLocaleDateString('en-CA')
        groupedData[date] = (groupedData[date] || 0) + 1
      })

      for (const date in groupedData) {
        cumulativeTotal += groupedData[date]
        chartData.push({ date, [label]: cumulativeTotal })
      }

      setChartData(chartData)
    } catch (error) {
      console.error(`Error fetching chart data for ${resource}:`, error)
    }
  }

  useEffect(() => {
    fetchTotal('Partners', setPartnersTotal)
    fetchChartData('Partners', setPartnersChartData, 'Partners')
    fetchTotal('Campaigns', setCampaignsTotal)
    fetchChartData('Campaigns', setCampaignsChartData, 'Campaigns')
    fetchTotal('UserDeposits', setUserDepositsTotal)
    fetchChartData('UserDeposits', setUserDepositsChartData, 'UserDeposits')
    fetchTotal('Users', setUsersTotal)
    fetchChartData('Users', setUsersChartData, 'Users')
  }, [dataProvider])

  return (
    <>
      <div className={classes.section}>
        <Card>
          <CardHeader title="Welcome to the administration" />
          <CardContent>
            Aggregating and curating high-quality yield opportunities (deals) from partner
            protocols so LPs can discover and deploy capital more efficiently
          </CardContent>
        </Card>
      </div>

      <Card sx={{ marginBottom: '1rem' }}>
        <CardHeader title={`Users Total: ${UsersTotal}`} />
        <BaseOneEntityChart
          data={UsersChartData}
          index="date"
          categories={['Users']}
          colors={['#4b88a2']}
        />
      </Card>
      <Card sx={{ marginBottom: '1rem' }}>
        <CardHeader title={`UserDeposits Total: ${UserDepositsTotal}`} />
        <BaseOneEntityChart
          data={UserDepositsChartData}
          index="date"
          categories={['UserDeposits']}
          colors={['#607d8b']}
        />
      </Card>
      <Card sx={{ marginBottom: '1rem' }}>
        <CardHeader title={`Campaigns Total: ${CampaignsTotal}`} />
        <BaseOneEntityChart
          data={CampaignsChartData}
          index="date"
          categories={['Campaigns']}
          colors={['#10b981']}
        />
      </Card>
      <Card>
        <CardHeader title={`Partners Total: ${PartnersTotal}`} />
        <BaseOneEntityChart
          data={PartnersChartData}
          index="date"
          categories={['Partners']}
          colors={['#3b82f6']}
        />
      </Card>
    </>
  )
}
